import { CreateRoute } from "../../CreateRouter";
import { authRoutes } from "./routes";

export const AuthRouter = () => CreateRoute(authRoutes);
